import { render, staticRenderFns } from "./ConsentForm.vue?vue&type=template&id=4ac98d96"
import script from "./ConsentForm.vue?vue&type=script&lang=js"
export * from "./ConsentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0___9f125e03a595eb473706425b4250c766/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports